/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:01:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-01-12 09:58:12
 */
import req from "@/utils/request";

//  根据栏目id查询模型参数
export const selectModelByColumnId = (params) => req.post("/site-service/m/model/selectModelByColumnId", params);

// 图片资源列表
export const selectPage = (params) => req.post("/site-service/m/cover/selectPage", params);

// 图片资源保存
export const coverCreate = (params) => req.post("/site-service/m/cover/create", params);

// 新增稿件
export const createManuscript = (params) => req.post("/site-service/m/manuscript/create", params);

// 保存草稿
export const createDraft = (params) => req.post("/site-service/m/manuscript/createDraft", params);

// 修改稿件
export const updateManuscript = (params) => req.post("/site-service/m/manuscript/update", params);

// 审核通过
export const updateApproved = (params) => req.post("/site-service/m/manuscript/updateApproved", params);

// 审核驳回
export const updateFail = (params) => req.post("/site-service/m/manuscript/updateFail", params);

// 上传文件
export const uploadFile = (params) => req.post("/site-service/m/model/uploadFile", params);

// 稿件详情
export const manuscriptDetails = (params) => req.post("/site-service/m/manuscript/details", params);

// 当前用户配置的站点
export const getSiteByUserId = (params) => req.post("/site-service/m/site/getSiteByUserId", params);

// 栏目树列表
export const columnTree = (params) => req.post("/site-service/m/site/column/tree", params);

// 链接列表
export const selectLinksPage = (params) => req.post("/site-service/m/manuscript/selectLinksPage", params);

// 修改保存稿件数据
export const saveManuscript = (params) => req.post("/site-service/m/manuscript/saveManuscript", params);

// 历史版本
export const selectList = (params) => req.post("/site-service/m/history/selectList", params);

// 历史版本详情
export const selectOne = (params) => req.post("/site-service/m/history/selectOne", params);

// Word导入
export const importWordToHtml = (params) => req.post("/site-service/m/manuscript/importWordToHtml", params);

// Ppt导入
export const importPptToHtml = (params) => req.post("/site-service/m/manuscript/importPptToHtml", params);

// Pdf导入
export const importPdfToHtml = (params) => req.post("/site-service/m/manuscript/importPdfToHtml", params);

// Excel导入
export const importExcelToHtml = (params) => req.post("/site-service/m/manuscript/importExcelToHtml", params);

// 识别关键字
export const keyWordsExtract = (params) => req.post("/site-service/m/characterRecognition/keyWordsExtract", params);

// 错敏检测
export const textCorrectionExtract = (params) => req.post("/site-service/m/characterRecognition/textCorrectionExtract", params);

// 预览
export const previewManuscript = (params) => req.post("/front-service/m/previewManuscript", params);

export const selectListPage = (params) => req.post("/media-service/m/wxGrant/selectListPage", params);

export const getIndexNumber = (params) => req.post("/site-service/m/model/getIndexNumber", params);
export const importUrlToHtml = (params) => req.post("/site-service/m/manuscript/importUrlToHtml", params);
export const darkChainDetection = (params) => req.post("/site-service/m/manuscript/darkChainDetection", params);

export const selectListPageWeiBo = (params) => req.post("/media-service/m/weiBo/selectListPage", params);
export const selectManuscriptDetails = (params) => req.post("/site-service/m/push/selectManuscriptDetails", params);
export const updateManuscriptAdopt = (params) => req.post("/site-service/m/push/updateManuscript", params);

